module.exports = __webpack_public_path__ + "img/qrcode_for_gh.7d216e76.jpg";